export enum MassiveRequestActions {
  EDIT_ACTION = 'edit',
  PROGRAM_ACTION = 'program',
}
